import { reactQueryPost } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers/internalApi";
import { useMutation } from "react-query";

export const useCreateBotChat = () => {
  const { mutateAsync: createChat } = useMutation({
    mutationFn: (botValues: any) =>
      reactQueryPost(internalApi.communityInbox.create(), {
        community_bot_profile_id: botValues.id,
        body: botValues.body || null,
      }),
    onError: err => {
      console.error("Error while creating chat", err);
    },
  });

  return {
    createChat,
  };
};
